module.exports = "<div style=\"display:none\" [innerHTML]=\"this.stylePage\"></div>\n\n<div [innerHTML]=\"htmlPage\"></div>\n\n<router-outlet></router-outlet>"